export default __webpack_public_path__ + "static/media/default-ability@3x.e9e55476.png";